<template>
  <div id="main-wrapper" :class="{ chromeless: chromeless }">
    <navbar v-if="!chromeless"/>
    <slot/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import navbar from '../navbar'

export default {
  components: {
    navbar
  },
  computed:{
    ...mapState('config', {
      chromeless: 'chromeless'
    })
  }
}
</script>

<style lang="scss" scoped>
#main-wrapper {
  height: 100%;

  &.chromeless{
    background-color:transparent;

    .page{
      background:transparent !important;
      padding:5px 5px;
      margin:auto auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/main-wrapper/index.vue